import * as React from 'react';
import { flow } from 'lodash';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {Row, Col, Modal} from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import FaSpinner from 'react-icons/fa/spinner';
import LoginForm from './components/LoginForm';
import {IStore} from '../../../../redux/IStore';
import { IChannel } from '../../../../data/api/models';
import {IAuthState} from '../../../../services/auth/models';
import { reduxForm, formValueSelector, InjectedFormProps } from 'redux-form';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import {Email} from '../../../../components/Email';

interface ILoginProps extends InjectedFormProps {
  actions: {
    auth: IAuthActions;
    push: (route: string) => void;
  };
  channel: IChannel;
  loginFailed: boolean;
  auth: IAuthState;
  redirectTo ?: string;
  showHeader ?: boolean;
  embed?: boolean;
}

class Login extends React.Component<ILoginProps> {

  public static defaultProps: Partial<ILoginProps> = {
    redirectTo: '/account/summary',
    showHeader: true,
    embed: false,
  };

  private handleSubmit = (formValues) => {
    const { actions } = this.props;
    const dob = moment(formValues.dob, 'DD/MM/YYYY').format('YYYY-MM-DD');

    return actions.auth.login(formValues.email, formValues.password, dob).then(() => {
      actions.push(this.props.redirectTo);
    });
  }

  public render() {
    const { loginFailed, auth } = this.props;

    return (
      <div className="login-content-container">
        <Row className="page-container animated fadeIn">
          <Col xs={12}>
            <div className="customer-section-title">
              {this.props.showHeader && (
                <h4>Customer Account <hr /></h4>
              )}
              {!auth.hasPasswordBeenReset ? (
                <div>
                  {loginFailed && (
                    <span className="error-block-container">
                      Login failed
                    </span>
                  )}
                  <LoginForm embed={this.props.embed} onSubmit={this.handleSubmit} />
                </div>
              ) : (
                <div className="redirect">
                  <FaSpinner className="fa-spin spin-icon"/>
                  <p>
                    You are now being redirected...
                  </p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'login',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');

      return {
        tripType,
        auth: state.auth,
        channel: state.branding.channel,
        loginFailed: state.auth.loginFailed,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({...authActions}, dispatch),
      },
    }),
  ),
])(Login);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/Login/index.tsx